$(document).ready(function() {
  var checkoutButtons = $("#checkout-buttons");
  checkoutButtons.addClass("disabled-checkout");
});

$(window).load(function() {
  var errorElement = $("#checkout-error");
  var checkoutButtons = $(".checkout-buttons");
  $("#pickup-instructions").hide();
  errorElement.text("");
  checkoutButtons.removeClass("disabled-checkout");
  
  /*$('#cart').submit(function(e){
    // 
    if (true){
      e.preventDefault()
    }
  });*/
  
  function runValidation() {    
    $("#pickup-instructions").hide();
    errorElement.text("");
    checkoutButtons.removeClass("disabled-checkout");
    
    if (!globalFields.isCartPage) {
      $("#cartSpecialInstructions").remove();
      checkoutButtons.remove();
      return;
    }
      
    var kombuchaCount = 0;
    var veggieCount = 0;
    var bottleDepositCount = 0;
    var bottleDepositVariantId = "7971219397";
    var kombuchaKitVariantId = "1021702772";
    var scobyVariantId = "771555837";
    var containsKombucha = false;
    var bottleDepositTotal = 0;
    var kombuchaError = "We are unable to ship kombucha.";
    var veggieError = "Veggies can only be shipped in quantity of 4, 8, or 12. You may mix varieties!";
    var localDeliveryError = "Delivery is only available for $95+ orders (excluding bottle deposits).";
    var bottleDepositError = "Bottle deposit charges are missing";
    var orderType = $('.shipping-method').find('input:checked').val();

    $(".cart-row").each(function( index ) {
      var productType = $(this).data("product-type");
      var productId = $(this).data("product-id");
      var price = $(this).data("price");
      var count = $(this).data("qty");

      if(productType == "Veggies") {
        veggieCount = veggieCount + parseInt(count); 
      }

      if(productType == "Kombucha" && productId != bottleDepositVariantId && productId != kombuchaKitVariantId && productId != scobyVariantId) {
         kombuchaCount = kombuchaCount + parseInt(count); 
      }
      
      if (productId == bottleDepositVariantId) { //bottle deposit variant ID
         bottleDepositCount = bottleDepositCount + parseInt(count);         
      }
      //else {
      //  var totalPrice = parseInt(price) * parseInt(count);
      //  cartTotalExceptBottleDeposits = cartTotalExceptBottleDeposits + totalPrice;   
      //}
    });
    
    bottleDepositTotal = bottleDepositCount * 300; // TO DO get price of deposit
    
    // Add bottle deposits to cart
    if (bottleDepositCount != kombuchaCount) {
      
      var items = {
          7971219397: kombuchaCount
        };

      var params = {
          type: 'POST',
          url: '/cart/update.js',
          data: { updates: items },
          dataType: 'json',
          success: function(stuff) { 
            window.location.href = '/cart';
          }
      };
      $.ajax(params);
      
    }

    // Check Shipping Restrictions
    if (orderType == "Shipping") {
      if (veggieCount > 0 && (veggieCount != 4 && veggieCount != 8 && veggieCount != 12)) {
         errorElement.text(veggieError);
         checkoutButtons.addClass("disabled-checkout");
      }

      if (kombuchaCount > 0) {
        errorElement.text(kombuchaError); 
        checkoutButtons.addClass("disabled-checkout");
      }
    }
    
    if (orderType == "Local Delivery") {
      var cartTotalExcludingBottleDeposits = (window.cartSubtotal) - bottleDepositTotal/100;
      if (cartTotalExcludingBottleDeposits < 95) {
         errorElement.text(localDeliveryError);
         checkoutButtons.addClass("disabled-checkout");
      }
    }
    
    if (orderType == "Store Pickup") {
       $("#pickup-instructions").show();
       $("#pickup-instructions").insertAfter("#shipping-methods");
    }
    
    // Disable checkout if kombucha bottle deposit is off just in case API call takes awhile
    if (bottleDepositCount != kombuchaCount) {
       errorElement.text(bottleDepositError); 
       checkoutButtons.addClass("disabled-checkout");
    }
  }
  
  function setShippingMethodValue() {
      var selectedShippingMethod = $('.shipping-method').find('input:checked').val();
      $("#order-type").val(selectedShippingMethod);
  }
  
  function disableDeliveryDates() {
      $("#dateLocalDelivery_table tbody tr").each(function () {
        $(this).find("td").eq(0).removeClass().addClass("picker__day picker__day--infocus picker__day--disabled").attr("aria-disabled", "true").click(function(event){
          event.stopPropagation();
        });
            $(this).find("td").eq(1).removeClass().addClass("picker__day picker__day--infocus picker__day--disabled").attr("aria-disabled", "true").click(function(event){
          event.stopPropagation();
        });
            $(this).find("td").eq(6).removeClass().addClass("picker__day picker__day--infocus picker__day--disabled").attr("aria-disabled", "true").click(function(event){
          event.stopPropagation();
        });

      });
  }
  
  function disablePickupDates() {
    var selectedCompany = $("[name='attributes[Pickup-Location-Company]']").val();
    
    if (selectedCompany == "HEX Ferments - NASA") {
      $("#date_table").find("[aria-label='20 June, 2020']").removeClass().addClass("picker__day picker__day--infocus picker__day--disabled").attr("aria-disabled", "true").click(function(event){
          event.stopPropagation();
      });
    }
  }
  
  var shippingMethods = $(".attributes-checkout-method");

  for (var i = 0; i < shippingMethods.length; i++) {
      shippingMethods[i].addEventListener('change', function() {
          runValidation();
          setShippingMethodValue();
      });
  }
  
  runValidation();
  setShippingMethodValue();
  $("#dateLocalDelivery").click(function() {
    disableDeliveryDates();
  });
  $(".picker__holder").on("click", "div", function() {
    disableDeliveryDates();
  });
  
  // for pickup date time
  $("#datetime").click(function() {
    disablePickupDates();
    
    $("#outlet .picker__holder").on("click", "div", function() {
      disablePickupDates();
    });
  });
  
});

